import { render, staticRenderFns } from "./DevView.vue?vue&type=template&id=5c965d06"
import script from "./DevView.vue?vue&type=script&lang=js"
export * from "./DevView.vue?vue&type=script&lang=js"
import style0 from "./DevView.vue?vue&type=style&index=0&id=5c965d06&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports